<template>
  <div class="help-page">
    <iframe class="help-iframe" :src="src"> </iframe>
  </div>
</template>

<script>
export default {
  data(){
    return {
      pageTitle: "",
      src: 'https://bangzhu.xiaogj.com/',
    }
  },
  created(){
    if (this.$route.params.src) {
      this.src = this.$route.params.src;
    }
    app.tool.setDocTitle(this.$route.params.pageTitle || '帮助中心');
  },
};
</script>

<style lang="scss" scoped>
.help-page {
  position: absolute;
  left: 0;
  right: 0;
  // bottom: env(safe-area-inset-bottom);
  top: 0;
  z-index: 2;
  overflow: hidden;

  .help-iframe {
    border: none;
    width: 100%;
    height: 100%;
  }
}
</style>